import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import { FaHeadphonesAlt } from "react-icons/fa";
import { MdKeyboardArrowDown, MdOutlineClose } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import useDeviceType from "../../hook/useDeviceType";
import { closeChat, openChat } from "../../redux/action/member/memberAction";
import { isLoggedIn } from "../../utils/isLoggedIn";
import { useNavigate } from "react-router";
import LoadingBlock from "../../components/Loading/LoadingBlock";

import logo from "../../images/Logo/main-logo.webp";
import { Loader } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

const ServicePing = ({ isGameBox }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`gamebox.${key}`);

  const [dragging, setDragging] = useState(false);
  const [dragStartTime, setDragStartTime] = useState(0);
  const [iframeIsLoading, setIframeIsLoading] = useState(true);

  const isMobile = useDeviceType() === "Mobile";

  const memberData = useSelector((state) => state.isMemberInfo);
  const openChatRoom = useSelector((state) => state.isOpenChatRoom);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleStart = () => {
    setDragStartTime(Date.now());
    setDragging(false);
  };

  const handleDrag = () => {
    setDragging(true);
  };

  const handleStop = () => {
    if (Date.now() - dragStartTime < 200) {
      if (openChatRoom) {
        dispatch(closeChat());
      } else {
        if (isLoggedIn()) {
          dispatch(openChat());
        } else {
          navigate("service-group");
        }
      }
    }
    setDragging(false);
  };

  useEffect(() => {
    setIframeIsLoading(true);
  }, [openChatRoom]);

  const handleOpenChat = () => {
    if (openChatRoom) {
      dispatch(closeChat());
    } else {
      if (isLoggedIn()) {
        dispatch(openChat());
      } else {
        navigate("service-group");
      }
    }
  };

  return (
    <>
      {/* <Draggable onStart={handleStart} onDrag={handleDrag} onStop={handleStop}> */}
      <section
        onClick={() => {
          handleOpenChat();
        }}
        className={`${
          isGameBox && isMobile ? "hidden" : ""
        }  fixed z-[999999] cursor-pointer text-light-white text-2xl bottom-[100px] md:right-[50px] right-[15px] border-b-[#b34600] border-b-[3px] border-x-[1px] border-x-[#da5200] border-t-[#da5200] border-t-[0.5px] shadow-lg bg-main-color shadow flex items-center justify-center rounded-full md:w-[55px] md:h-[55px] w-[44px] h-[44px]`}
      >
        <AnimatePresence>
          {openChatRoom && !isMobile ? (
            <motion.section
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0 }}
              transition={{ duration: 0.2 }}
              style={{ originX: 1, originY: 1 }}
              className={`md:w-[400px] max-[640px]:!transform-none fixed md:absolute bottom-[60px] right-0 md:h-[70vh] w-[90vw] h-[450px] overflow-hidden rounded-xl bg-base-light-white dark:bg-base-light-dark shadow`}
            >
              {iframeIsLoading && (
                <div className="h-full w-full flex flex-col gap-[5px] items-center justify-center">
                  <img
                    src={logo}
                    className="w-[200px] h-[100px] object-cover"
                  />
                  <Loader
                    className="!text-main-color"
                    active
                    size={"big"}
                    inline="centered"
                  >
                    {i18n("loading")}
                  </Loader>
                </div>
              )}

              <iframe
                onLoad={() => {
                  setIframeIsLoading(false);
                }}
                className="w-full h-full"
                src={`https://chatsys4.911win.fun/mobile/index/home?visiter_id=${memberData?.uid}&visiter_name=${memberData?.memId}&avatar=&business_id=admin&groupid=0&lang=vn&ismobile=1`}
              ></iframe>
            </motion.section>
          ) : null}
        </AnimatePresence>
        {openChatRoom ? <MdKeyboardArrowDown /> : <FaHeadphonesAlt />}
      </section>
      {/* </Draggable> */}
      <AnimatePresence>
        {openChatRoom && isMobile ? (
          <motion.section
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            transition={{ duration: 0.2 }}
            style={{ originX: 1, originY: 1 }}
            className="z-[999999] fixed top-0 right-0 w-[100vw] webkit-height overflow-hidden bg-base-light-white dark:bg-base-light-dark shadow"
          >
            <MdOutlineClose
              onClick={() => {
                dispatch(closeChat());
              }}
              className="absolute top-[10px] right-[10px] text-2xl text-white"
            />
            {iframeIsLoading && (
              <div className="h-full w-full flex flex-col gap-[5px] items-center justify-center">
                <img src={logo} className="w-[200px] h-[100px] object-cover" />
                <Loader
                  className="!text-main-color"
                  active
                  size={"big"}
                  inline="centered"
                >
                  {i18n("loading")}
                </Loader>
              </div>
            )}
            <iframe
              onLoad={() => {
                setIframeIsLoading(false);
              }}
              className="w-full h-full"
              src={`https://chatsys4.911win.fun/mobile/index/home?visiter_id=${memberData?.uid}&visiter_name=${memberData?.memId}&avatar=&business_id=admin&groupid=0&lang=vn&ismobile=1`}
            ></iframe>
          </motion.section>
        ) : null}
      </AnimatePresence>
    </>
  );
};

export default ServicePing;
